import ActionButton from '../../../../common/components/documentViewer/actionButton';
import { IActionButtonCommonProps } from '../../../../common/typings/DocumentViewer/actionButtonCommonProps';
import { commonTestIds } from '../../../../common/utils/commonTestIds';
import DialogCloseListener from '../../../../common/utils/dialogCloseListener';
import { executeIfLoggedIn } from '../../../../common/utils/logonUtils';
import RfeWebDialog from '../../../../common/utils/rfeWebDialog';
import { IOrderViewerMainStore } from '../../typing/stores';
import { NonAnonymousActions } from '../../utils/constants';
import { Icons } from 'copyright-clearance-center-common-ui';
import { inject } from 'mobx-react';
import { forwardRef } from 'react';

interface IRequestNewVersionButton {
	orderId?: number;
	orderViewLogonUrl?: string;
}

const RequestNewVersionButton: React.ForwardRefExoticComponent<
	IRequestNewVersionButton & IActionButtonCommonProps & React.HTMLProps<HTMLButtonElement>
> = forwardRef((props, ref) => {
	const dialogCloseHandler = () => {
		const url = 'order/cart.aspx?_s=y';
		const mainWindow = $.iframe.topWindow();
		if (mainWindow) {
			const header = mainWindow.document.getElementById('GlobalHeader');
			const headerHidden = header == null;

			if (headerHidden) {
				mainNavigateContent(RFE.MainPage + '?redir=' + encodeURIComponent(url));
				return;
			}
		}

		mainNavigateContent(url);
	};

	const handler = () => {
		executeIfLoggedIn(
			() => {
				DialogCloseListener.subscribe('updateDocument', dialogCloseHandler);
				RfeWebDialog.show(`order/DocUpdateDlg.aspx?oId=${props.orderId}`);
			},
			props.orderViewLogonUrl,
			NonAnonymousActions.RequestNewVersion
		);
	};

	return (
		<ActionButton
			label={localize('Request new version')}
			handler={handler}
			icon={Icons.SwitchIcon}
			isPrimary={props.isPrimary}
			className={props.className}
			testId={commonTestIds.requestNewVersionBtn}
			controlledBy={props.controlledBy}
			ref={ref}
		/>
	);
});
RequestNewVersionButton.displayName = 'RequestNewVersionButton';

export default inject((stores: IOrderViewerMainStore) => ({
	orderId: stores.orderViewerStore.viewModel.orderId,
	orderViewLogonUrl: stores.orderViewerStore.viewModel.orderLogonViewerUrl.logonUrl
}))(RequestNewVersionButton);
